module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps"
  }, [_c('Steps', {
    attrs: {
      "current": _vm.stepNum
    }
  }, [_c('Step', {
    attrs: {
      "title": "信息校验",
      "content": ""
    }
  }), _vm._v(" "), _c('Step', {
    attrs: {
      "title": "绑定手机",
      "content": ""
    }
  }), _vm._v(" "), _c('Step', {
    attrs: {
      "title": "设置密码",
      "content": ""
    }
  }), _vm._v(" "), _c('Step', {
    attrs: {
      "title": "激活完成",
      "content": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5eca2a4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/steps.vue
// module id = 197
// module chunks = 0